import * as React from "react";
import { Avatar, Box, ListItemIcon, Typography } from "@mui/material";
import { MINI_DRAWER_WIDTH } from "./constants";

interface SidebarItemIconProps {
  mini: boolean;
  nested?: boolean;
  title: string;
  icon?: React.ReactNode;
  selected?: boolean;
}

const SidebarItemIcon = ({
  mini,
  nested = false,
  title,
  icon,
  selected,
}: SidebarItemIconProps) => {
  const color = selected ? "primary.main" : "text.secondary";

  const renderIcon = icon
    ? React.cloneElement(icon as React.ReactElement, {
        sx: { fontSize: nested ? 18 : 20, color },
      })
    : mini && (
        <Avatar
          sx={{
            fontSize: 10,
            height: 20,
            width: 20,
            bgcolor: selected ? "primary.main" : "background.paper",
            color: selected ? "white" : "text.primary",
          }}
        >
          {title
            .split(" ")
            .slice(0, 2)
            .map((w) => w[0]?.toUpperCase())
            .join("")}
        </Avatar>
      );

  if (mini && nested) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          justifyContent: "flex-start",
          px: 0.1,
          py: 0.5,
        }}
      >
        {renderIcon}
        <Typography
          variant="body2"
          sx={{
            fontSize: 13,
            color: selected ? "primary.main" : "text.primary",
            whiteSpace: "nowrap",
          }}
        >
          {title}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={
        mini
          ? {
              position: "absolute",
              left: "50%",
              top: "calc(50% - 6px)",
              transform: "translate(-50%, -50%)",
            }
          : undefined
      }
    >
      <ListItemIcon
        sx={{
          color,
          display: "flex",
          alignItems: "center",
          justifyContent: mini ? "center" : "flex-start",
          minWidth: mini ? "auto" : 32,
        }}
      >
        {renderIcon}
      </ListItemIcon>

      {mini && !nested && (
        <Typography
          variant="caption"
          sx={{
            position: "absolute",
            bottom: -18,
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: 10,
            fontWeight: 500,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: MINI_DRAWER_WIDTH - 28,
          }}
        >
          {title}
        </Typography>
      )}
    </Box>
  );
};

export default SidebarItemIcon;
